import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { PERIOD_BASED_REPORT_QUERY } from '../../../graphql.js'
import { Link } from 'react-router-dom'
import { csvUrl, getData, getInputParams } from '../CustomUtils.js'
import LargeRowHandler from '../LargeRowHandler.js'

const PERIOD_BASED_REPORT = gql(PERIOD_BASED_REPORT_QUERY)

export default function PeriodBasedDetails({ location }) {
  console.log('PeriodBasedDetails rendered:')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, PERIOD_BASED_REPORT, 'periodBasedReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const body = []
    for (let i = 0; i < results.detail.length; i++) {
      let row = []
      row.push(<td key={i}>{i+1}</td>)
      for (let j = 0; j < results.detail[i].length; j++) {
        row.push(<td key={results.detail[i][j]}>{results.detail[i][j]}</td>)
      }
      row.push(<td key={-1} style={{verticalAlign: 'middle', width: 'auto'}}><Link to={`/object/${results.detail[i][3]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View</Button></Link></td>)
      body.push(<tr key={i}>{row}</tr>)
    }

    const inputs = getInputParams(location)
    let dateFrom = 'Inception'
    let dateTo = 'Present'
    if (inputs.dateFrom) {
      dateFrom = inputs.dateFrom.split('-')
      dateFrom = dateFrom[1] + '-' + dateFrom[2] + '-' + dateFrom[0]
    }
    if (inputs.dateTo) {
      dateTo = inputs.dateTo.split('-')
      dateTo = dateTo[1] + '-' + dateTo[2] + '-' + dateTo[0]
    }
    let claimsText
    switch (inputs.reportType) {
      case 'Entered':
      case 'Closed':
      case 'Re-closed':
        claimsText = `Claims ${inputs.reportType}`
        break
      case 'Zero Pay':
      case 'Positive Pay':
        claimsText = `${inputs.reportType} Claims`
        break
      default:
        claimsText = inputs.reportType
    }
    const dateInputs = `(From ${dateFrom} to ${dateTo})`
    const injuryName = inputs.injuryName ? `with Current Diagnosis of ${inputs.injuryName}` : ''
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl(`Asbestos/periodBasedReport/${claimsText}${dateInputs}${injuryName}`, location)} resultsLength={results.detail.length} />
        </div>
        <h5 style={{textAlign: 'center'}}>{claimsText} {dateInputs} {injuryName}</h5>
        <br/>
        <div/>
        <Table bordered style={{width: 'auto', marginLeft: 'auto', marginRight: 'auto'}}>
          <thead>
            <tr>
              <th>#</th>
              <th>Last Name</th>
              <th>First Name</th>
              <th>SSN</th>
              <th>Document ID</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {body}
          </tbody>
        </Table>
        <div/>
      </div>
    )
  }
}
